export function extractDomainPrefix(input: string): string | null {
  if (!input) return null;
  let raw = input.trim().toLowerCase();

  try {
    if (raw.includes('://')) {
      const url = new URL(raw);
      raw = url.hostname;
    }
  } catch (_) {
  }

  raw = raw.replace(/^https?:\/\//, '').replace(/\/$/, '');

  if (raw.includes('.')) {
    const host = raw.replace(/[^a-z0-9.-]/g, '').replace(/\.+/g, '.');
    const suffixes = ['.retail.lightspeed.app', '.shoplightspeed.com'];
    for (const suffix of suffixes) {
      if (host.endsWith(suffix)) {
        const first = host.split('.')[0];
        const sanitized = first.replace(/[^a-z0-9-]/g, '');
        return sanitized.length ? sanitized : null;
      }
    }
    return null;
  }

  const sanitized = raw.replace(/[^a-z0-9-]/g, '');
  return sanitized.length ? sanitized : null;
}